export enum QuestionOrder {
    NONE = "NONE",
    MAIS_ANTIGAS = "MAIS_ANTIGAS",
    MAIS_CURTIDAS = "MAIS_CURTIDAS"
}
